<section>
  <div>
    <h1>Privacy Policy</h1>
    <!-- <button [class.login]="context === 'login'" [class.main]="context === 'main'" (click)="back.emit()"> -->
    <button [ngClass]="[context]" (click)="back.emit()">
      <img src="assets/icons/back.svg" alt="back button">
    </button>
  </div>
  <h3>1. Data protection at a glance</h3>
  <h5>General information</h5>
  <p>
    The following information provides a simple overview of what happens to your
    personal data when you visit this website. Personal data is any data that
    can be used to identify you personally. For detailed information on data
    protection, please refer to our privacy policy listed below this text.
  </p>
  <h5>Data collection on this website</h5>

  <h6>Who is responsible for data collection on this website?</h6>
  <p>
    Data processing on this website is carried out by the website operator.
    Their contact details can be found in the “Information on the responsible
    body” section of this privacy policy.
  </p>
  <h6>How do we collect your data?</h6>
  <p>
    Your data is collected when you provide it to us. This may include, for
    example, data that you enter in a contact form. Other data is collected
    automatically or with your consent when you visit the website by our IT
    systems. This is primarily technical data (e.g., Internet browser, operating
    system, or time of page view). This data is collected automatically as soon
    as you enter this website.
  </p>
  <h6>What do we use your data for?</h6>
  <p>
    Some of the data is collected to ensure that the website is provided without
    errors. Other data may be used to analyze your user behavior. If contracts
    can be concluded or initiated via the website, the transmitted data will
    also be processed for contract offers, orders, or other order inquiries.
  </p>
  <h6>What rights do you have regarding your data?</h6>
  <p>
    You have the right to obtain information about the origin, recipient, and
    purpose of your stored personal data at any time and free of charge. You
    also have the right to request the correction or deletion of this data. If
    you have given your consent to data processing, you can revoke this consent
    at any time for the future. In addition, you have the right, under certain
    circumstances, to request the restriction of the processing of your personal
    data. Furthermore, you have the right to lodge a complaint with the
    competent supervisory authority. You can contact us at any time if you have
    any questions about this or other data protection issues.
  </p>

  <h3>2. Hosting</h3>
  <p>We host the content of our website with the following provider:</p>
  <h5>All-Inkl</h5>
  <p>
    The provider is ALL-INKL.COM - Neue Medien Münnich, owner René Münnich,
    Hauptstraße 68, 02742 Friedersdorf (hereinafter referred to as All-Inkl).
    For details, please refer to All-Inkl's privacy policy:
    <a href="https://all-inkl.com/datenschutzinformationen/">
      https://all-inkl.com/datenschutzinformationen/
    </a>
  </p>
  <p>
    The use of All-Inkl is based on Art. 6 (1) lit. f GDPR. We have a legitimate
    interest in ensuring that our website is displayed as reliably as possible.
    If corresponding consent has been requested, processing is carried out
    exclusively on the basis of Art. 6 (1) (a) GDPR and § 25 (1) TDDDG, insofar
    as the consent includes the storage of cookies or access to information on
    the user's terminal device (e.g., device fingerprinting) within the meaning
    of the TDDDG. Consent can be revoked at any time.
  </p>
  <h6>Order processing</h6>
  <p>
    We have concluded an order processing agreement (AVV) for the use of the
    above-mentioned service. This is a contract required by data protection law,
    which ensures that the personal data of our website visitors is only
    processed in accordance with our instructions and in compliance with the
    GDPR.
  </p>
  <h3>3. Legal information and mandatory information</h3>
  <h5>Privacy policy</h5>
  <p>
    The owners of this website take the protection of your personal data very
    seriously. We treat your personal data confidentially and in accordance with
    the statutory data protection regulations and this privacy policy.
  </p>
  <p>
    When you use this website, various personal data is collected. Personal data
    is data that can be used to identify you personally. This privacy policy
    explains what data we collect and what we use it for. It also explains how
    and for what purpose this is done.
  </p>
  <p>
    We would like to point out that data transmission over the Internet (e.g.,
    when communicating by email) may be subject to security vulnerabilities. It
    is not possible to completely protect data from access by third parties. We
    use various encryption methods to protect your data.
  </p>
  <h5>Information about the responsible body</h5>
  <p>The responsible body for data processing on this website is:</p>
  <p>
    Felicia Primadita Tretter <br />
    Wuppertaler Straße 30a <br />
    D-51067 Cologne
  </p>
  <p>
    Phone: +49 (0) 17662678239 <br />
    Email: felicia.primadita&#64;web.de
  </p>
  <p>
    The responsible body is the natural or legal person who, alone or jointly
    with others, decides on the purposes and means of processing personal data
    (e.g., names, email addresses, etc.). We would like to point out that data
    transmission over the Internet (e.g., when communicating by email) We would
    like to point out that data transmission over the Internet (e.g., when
    communicating by email) may have security gaps. Complete protection of data
    against access by third parties is not possible.
  </p>
  <h5>Storage duration</h5>
  <p>
    Unless a more specific storage period is specified in this privacy policy,
    your personal data will remain with us until the purpose for data processing
    no longer applies. If you assert a legitimate request for deletion or revoke
    your consent to data processing, your data will be deleted unless we have
    other legally permissible reasons for storing your personal data (e.g., tax
    or commercial law retention periods); in the latter case, deletion will take
    place after these reasons no longer apply.
  </p>
  <h5>
    General information on the legal basis for data processing on this website
  </h5>
  <p>
    If you have consented to data processing, we process your personal data on
    the basis of Art. 6 (1) (a) GDPR or Art. 9 (2) (a) GDPR, if special
    categories of data are processed in accordance with Art. 9 (1) GDPR. In the
    event of express consent to the transfer of personal data to third
    countries, data processing is also carried out on the basis of Art. 49(1)(a)
    GDPR. If you have consented to the storage of cookies or access to
    information on your end device (e.g., via device fingerprinting), data
    processing is also carried out on the basis of Section 25(1) TDDDG. Consent
    can be revoked at any time. If your data is necessary for the performance of
    a contract or for the implementation of pre-contractual measures, we process
    your data on the basis of Art. 6 (1) lit. b GDPR. Furthermore, we process
    your data if it is necessary to fulfill a legal obligation on the basis of
    Art. 6 (1) lit. c GDPR. Data processing may also be carried out on the basis
    of our legitimate interest pursuant to Art. 6 (1) lit. f GDPR. The relevant
    legal basis in each individual case is explained in the following paragraphs
    of this privacy policy.
  </p>
  <h5>Recipients of personal data</h5>
  <p>
    We work with various external parties in the course of our business
    activities. This sometimes requires the transfer of personal data to these
    external parties. We only pass on personal data to external parties if this
    is necessary for the fulfillment of a contract, if we are legally obliged to
    do so (e.g., disclosure of data to tax authorities), if we have a legitimate
    interest in the disclosure pursuant to Art. 6 (1) lit. f GDPR, or if another
    legal basis permits the disclosure of data. When using processors, we only
    disclose our customers' personal data on the basis of a valid contract for
    order processing. In the case of joint processing, a contract for joint
    processing is concluded.
  </p>
  <h5>Revocation of your consent to data processing</h5>
  <p>
    Many data processing operations are only possible with your express consent.
    You can revoke consent you have already given at any time. The legality of
    the data processing carried out until the revocation remains unaffected by
    the revocation.
  </p>
  <h5>
    Right to object to data collection in specific cases and to direct marketing
    (Art. 21 GDPR)
  </h5>
  <p>
    IF DATA PROCESSING IS BASED ON ART. 6(1)(e) OR (f) GDPR , YOU HAVE THE RIGHT
    TO OBJECT TO THE PROCESSING OF YOUR PERSONAL DATA AT ANY TIME FOR REASONS
    ARISING FROM YOUR PARTICULAR SITUATION; THIS ALSO APPLIES TO PROFILING BASED
    ON THESE PROVISIONS. ; THIS ALSO APPLIES TO PROFILING BASED ON THESE
    PROVISIONS. THE RESPECTIVE LEGAL BASIS ON WHICH PROCESSING IS BASED CAN BE
    FOUND IN THIS DATA PROTECTION DECLARATION. IF YOU OBJECT, WE WILL NO LONGER
    PROCESS YOUR PERSONAL DATA, UNLESS WE CAN PROVE THAT THERE ARE COMPELLING
    LEGITIMATE GROUNDS FOR THE PROCESSING THAT OVERRIDE YOUR INTERESTS, RIGHTS,
    AND FREEDOMS OR THE PROCESSING SERVES TO ASSERT, EXERCISE, OR DEFEND LEGAL
    CLAIMS (OBJECTION PURSUANT TO ART. 21(1) GDPR). IF YOUR PERSONAL DATA IS
    PROCESSED FOR DIRECT MARKETING PURPOSES, YOU HAVE THE RIGHT TO OBJECT AT ANY
    TIME TO THE PROCESSING OF YOUR PERSONAL DATA FOR THE PURPOSE OF SUCH
    ADVERTISING ; THIS ALSO APPLIES TO PROFILING, INSOFAR AS IT IS RELATED TO
    SUCH DIRECT ADVERTISING . IF YOU OBJECT, YOUR PERSONAL DATA WILL NO LONGER
    BE USED FOR DIRECT MARKETING PURPOSES (OBJECTION PURSUANT TO ART. 21(2)
    GDPR).
  </p>
  <h5>Right to lodge a complaint with the competent supervisory authority</h5>
  <p>
    In the event of violations of the GDPR, data subjects have the right to
    lodge a complaint with a supervisory authority, in particular in the Member
    State of their habitual residence, their place of work or the place of the
    alleged violation. The right to lodge a complaint exists without prejudice
    to other administrative or judicial remedies.
  </p>
  <h5>Right to data portability</h5>
  <p>
    You have the right to have data that we process automatically on the basis
    of your consent or in fulfillment of a contract handed over to you or to a
    third party in a common, machine-readable format. If you request the direct
    transfer of the data to another controller, this will only be done if it is
    technically feasible.
  </p>
  <h5>Information, correction, and deletion</h5>
  <p>
    Within the framework of the applicable legal provisions, you have the right
    to obtain information free of charge at any time about your stored personal
    data, its origin and recipients, and the purpose of data processing, and, if
    applicable, a right to correct or delete this data. You can contact us at
    any time for this purpose or if you have any further questions on the
    subject of personal data.
  </p>
  <h5>Right to restriction of processing</h5>
  <p>
    You have the right to request the restriction of the processing of your
    personal data. You can contact us at any time for this purpose. The right to
    restriction of processing exists in the following cases:
  </p>
  <ul>
    <li>
      If you dispute the accuracy of your personal data stored by us, we usually
      need time to verify this. For the duration of the verification, you have
      the right to request the restriction of the processing of your personal
      data.
    </li>
    <li>
      If the processing of your personal data was/is unlawful, you can request
      the restriction of data processing instead of deletion.
    </li>
    <li>
      If we no longer need your personal data, but you need it to exercise,
      defend, or assert legal claims, you have the right to request the
      restriction of the processing of your personal data instead of its
      erasure.
    </li>
    <li>
      If you have lodged an objection pursuant to Art. 21 (1) GDPR, a balance
      must be struck between your interests and ours. As long as it is not yet
      clear whose interests prevail, you have the right to request the
      restriction of the processing of your personal data
    </li>
  </ul>
  <p>
    If you have restricted the processing of your personal data, this data may –
    apart from its storage – only be processed with your consent or for the
    assertion, exercise, or defense of legal claims or for the protection of the
    rights of another natural or legal person or for reasons of important public
    interest of the European Union or a Member State.
  </p>
  <h3>4. Data collection on this website</h3>
  <h5>Comment function on this website</h5>
  <p>
    For the comment function on this page, in addition to your comment,
    information about the time the comment was created, your email address, and,
    if you are not posting anonymously, the username you have chosen will be
    stored.
  </p>
  <h6>Storage duration of comments</h6>
  <p>
    The comments and the associated data are stored and remain on this website
    until the commented content has been completely deleted or the comments have
    to be deleted for legal reasons (e.g., offensive comments).
  </p>
  <h6>Legal basis</h6>
  <p>
    Comments are stored on the basis of your consent (Art. 6 (1) (a) GDPR). You
    can revoke your consent at any time. To do so, simply send us an informal
    email. The legality of data processing operations that have already taken
    place remains unaffected by the revocation.
  </p>
  <h3>5. Plugins and tools</h3>
  <h5>Google Fonts</h5>
  <p>
    This site uses Google Fonts, which are provided by Google, to ensure
    consistent font display. When you visit a page, your browser loads the
    required fonts into your browser cache to display text and fonts correctly.
  </p>
  <p>
    For this purpose, the browser you are using must connect to Google's
    servers. This allows Google to know that this website has been accessed via
    your IP address. The use of Google Fonts is based on Art. 6 (1) lit. f GDPR.
    The website operator has a legitimate interest in the uniform display of the
    typeface on its website. If consent has been requested, processing is
    carried out exclusively on the basis of Art. 6 (1) lit. a GDPR and § 25 (1)
    TDDDG, insofar as the consent includes the storage of cookies or access to
    information on the user's terminal device (e.g., device fingerprinting)
    within the meaning of the TDDDG. Consent can be revoked at any time.
  </p>
  <p>
    If your browser does not support Google Fonts, a standard font from your
    computer will be used.
  </p>
  <p>
    For more information about Google Fonts, please visit
    <a href="https://developers.google.com/fonts/faq">
      https://developers.google.com/fonts/faq
    </a> and Google's privacy policy:
    <a href="https://policies.google.com/privacy?hl=de">
      https://policies.google.com/privacy?hl=de.
    </a>  
  </p>
  <p>
    The company is certified under the EU-US Data Privacy Framework (DPF). The
    DPF is an agreement between the European Union and the US that aims to
    ensure compliance with European data protection standards when data is
    processed in the US. Every company certified under the DPF undertakes to
    comply with these data protection standards. Further information on this can
    be obtained from the provider at the following link:
    <a href="https://www.dataprivacyframework.gov/participant/5780"
      >https://www.dataprivacyframework.gov/participant/5780</a>
  </p>
  <p>
    Source: <br />
    <a href="https://www.e-recht24.de">https://www.e-recht24.de</a>
  </p>
</section>
